import { useViewportWidth } from 'decorators/withViewportWidth';
import useMounted from './useMounted';

/**
 * Returns true only once mounted AND the viewport is confirmed desktop-sized.
 * Defaults to false on SSR/first paint, so desktop-only content is absent
 * from the DOM until proven necessary -- pair with a CSS breakpoint rule on
 * the "shown by default" side of the gate to avoid a mirrored flash there.
 *
 * @param {(width: number) => boolean} isDesktopWidth - a predicate function
 *   such as isFoundationLarge.
 */
export default function useIsDesktop(isDesktopWidth) {
	const { viewportWidth } = useViewportWidth();
	const mounted = useMounted();

	return mounted && isDesktopWidth(viewportWidth);
}
